import { render, staticRenderFns } from "./BtnDetalleCliente.vue?vue&type=template&id=a6e66864&scoped=true"
import script from "./BtnDetalleCliente.vue?vue&type=script&lang=js"
export * from "./BtnDetalleCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e66864",
  null
  
)

export default component.exports